import { Middleware } from "@nuxt/types"
import { isSitecoreRequest } from "~/utils/isSitecoreRequest"

const hasBeenInducted: Middleware = ({ store, app, query, route, redirect, req }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const { path } = route
  const { currentUser } = store.getters
  const {
    account: { termsConditionsConsent, analyticsConsent },
    membership: { inductedAt, nonMemberAccount }
  } = currentUser

  if (nonMemberAccount) {
    return
  }

  const welcomeRoute = app.localePath({ name: 'introduction-welcome' })
  const termsRoute = app.localePath({ name: 'introduction-terms' })
  // The business logic requires this order; this follows the screen order for induction
  const memberRequirementAndRoute = [
    [!termsConditionsConsent && path !== termsRoute, 'introduction-welcome'],
    [!termsConditionsConsent && path !== welcomeRoute, 'introduction-terms'],
    [analyticsConsent === null, 'introduction-analytics'],
    [!inductedAt, 'introduction-schedule']
  ].reverse()

  const redirectToRoute: string = memberRequirementAndRoute.reduce((redirectTo, [isInvalid, route]) => isInvalid ? route as string : redirectTo, '')

  if (!redirectToRoute) {
    return
  }

  const localePath = app.localePath({ name: redirectToRoute })

  if (path !== localePath) {
    return redirect(localePath, query)
  }
}

export default hasBeenInducted
